import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function WantedSwitchField({
  checked,
  disabled,
  disabledReason,
  onChange,
}: {
  readonly checked: boolean;
  readonly disabled: boolean;
  readonly disabledReason?: string | null;
  readonly onChange: (value: boolean) => void;
}) {
  const switchControl = (
    <Switch
      id="new-shift-wanted"
      type="button"
      checked={checked}
      disabled={disabled}
      onCheckedChange={onChange}
    />
  );

  return (
    <div className="flex flex-col gap-3 rounded-lg border border-[#E4E7EC] bg-[#F8FAFC] px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        <Label htmlFor="new-shift-wanted">원티드 반영</Label>
        <p className="mt-1 break-keep text-xs leading-5 text-muted-foreground">
          원티드 신청 화면에서 선택할 수 있는 근무 코드로 표시합니다.
        </p>
      </div>
      {disabled && disabledReason ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="inline-flex cursor-help">{switchControl}</span>
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-[260px] break-keep">
              <p>{disabledReason}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        switchControl
      )}
    </div>
  );
}

export function OffSwapSwitchField({
  checked,
  disabled,
  onChange,
}: {
  readonly checked: boolean;
  readonly disabled: boolean;
  readonly onChange: (value: boolean) => void;
}) {
  return (
    <div className="flex flex-col gap-3 rounded-lg border border-[#E4E7EC] bg-[#F8FAFC] px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        <Label htmlFor="edit-shift-off-swap">OFF 대체</Label>
        <p className="mt-1 break-keep text-xs leading-5 text-muted-foreground">
          초과 OFF가 발생했을 때 대체 코드로 사용할지 정합니다.
        </p>
      </div>
      <Switch
        id="edit-shift-off-swap"
        type="button"
        checked={checked}
        disabled={disabled}
        onCheckedChange={onChange}
      />
    </div>
  );
}

/**
 * 보건휴가 · 수면OFF 부여 대상 코드 스위치.
 *
 * OFF 대체와 서버 규칙이 같다(type !== '근무' · 그룹당 1개). 다만 OFF 대체는
 * OFF 자체를 후보에서 빼는 추가 조건이 있고 이쪽은 없다 — 휴가 코드가 OFF 계열이어도
 * 대상이 될 수 있기 때문이다.
 */
export function LeaveTargetSwitchField({
  id,
  label,
  description,
  checked,
  disabled,
  onChange,
}: {
  readonly id: string;
  readonly label: string;
  readonly description: string;
  readonly checked: boolean;
  readonly disabled: boolean;
  readonly onChange: (value: boolean) => void;
}) {
  return (
    <div className="flex flex-col gap-3 rounded-lg border border-[#E4E7EC] bg-[#F8FAFC] px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0">
        <Label htmlFor={id}>{label}</Label>
        <p className="mt-1 break-keep text-xs leading-5 text-muted-foreground">
          {description}
        </p>
      </div>
      <Switch
        id={id}
        type="button"
        checked={checked}
        disabled={disabled}
        onCheckedChange={onChange}
      />
    </div>
  );
}
